module.exports = __webpack_public_path__ + "static/media/nescafe.2f9c24d8.jpg";